import { render, staticRenderFns } from "./TableSelectAllTip.vue?vue&type=template&id=152ecfc8&scoped=true&"
import script from "./TableSelectAllTip.vue?vue&type=script&lang=ts&"
export * from "./TableSelectAllTip.vue?vue&type=script&lang=ts&"
import style0 from "./TableSelectAllTip.vue?vue&type=style&index=0&id=152ecfc8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152ecfc8",
  null
  
)

export default component.exports